import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import T from 'prop-types';
import CloseButton from './CloseButton';
import text from '../../../../text';
import Icon from '../../../icon/Icon';
export default function Header(param) {
    var isPreviewButtonHidden = param.isPreviewButtonHidden, isScreenshotButtonHidden = param.isScreenshotButtonHidden;
    return /*#__PURE__*/ React.createElement(Modal.Header, null, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row",
        style: {
            gap: 16
        }
    }, !isPreviewButtonHidden && /*#__PURE__*/ React.createElement(Button, {
        variant: "light",
        className: "row-action with-text icon-button"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "preview"
    }), /*#__PURE__*/ React.createElement("span", null, text('preview'))), !isScreenshotButtonHidden && /*#__PURE__*/ React.createElement(Button, {
        variant: "light",
        className: "row-action with-text icon-button"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "camera"
    }), /*#__PURE__*/ React.createElement("span", null, text('screenshot')))), /*#__PURE__*/ React.createElement(CloseButton, null));
}
Header.propTypes = {
    isPreviewButtonHidden: T.bool,
    isScreenshotButtonHidden: T.bool
};
